import { EnvironmentProviders, Provider } from "@angular/core";
import { AppConfiguration } from "./configuration/configuration";
import { MinimapProvider, Viewer3dProvider, ViewerProvider } from "@dvm.providers";
import { AppPreview } from "@configuration/preview";
import { AuthProvider } from "@auth.providers";
import { AmenitiesService } from "@services/amenities.service";
import { AnalyticsService } from "@services/analytics.service";
import { BottomSheetService } from "@services/components/bottom-sheet.service";
import { MinimapService } from "@services/components/minimap.service";
import { MobileButtonService } from "@services/components/mobile-button.service";
import { RelatedPreviewsService } from "@services/components/related-previews.service";
import { ConfigurationService } from "@services/configuration.service";
import { ConversorService } from "@services/conversor.service";
import { CredentialsService } from "@services/credentials.service";
import { DvmService } from "@services/dvm.service";
import { ViewDeterminationService } from "@services/dvm/view-determination.service";
import { ViewerService } from "@services/dvm/viewer.service";
import { Viewer3dService } from "@services/dvm/viewer3d.service";
import { VenueConfigurationsService } from "@services/dvm/venue-configurations.service";
import { FilterService } from "@services/filter.service";
import { LayoutService } from "@services/layout.service";
import { NavigationService } from "@services/navigation.service";
import { PopoverService } from "@services/popover.service";
import { PortalService } from "@services/portal.service";
import { PreviewService } from "@services/preview.service";
import { TemplateService } from "@services/template.service";
import { ToastService } from "@services/toast.service";
import { TranslationService } from "@services/translation.service";
import { UiService } from "@services/ui.service";
import { ViewService } from "@services/view.service";
import { ViewerRouteParamsService } from "@services/viewer-route-params.service";

/**
 * Providers funcionales de Sites Builder independientes del propietario de la sesión.
 *
 * Se registran también los servicios `providedIn: 'root'` para que un host lazy pueda
 * construirlos en el mismo EnvironmentInjector que APP_CONFIG, DVM y HttpClient.
 */
export const APP_CORE_PROVIDERS: Provider[] = [
    // CONFIGURATIONS
    AppConfiguration,
    AppPreview,

    // DVM SERVICES
    ViewerProvider,
    MinimapProvider,
    Viewer3dProvider,

    // APP-SCOPED SERVICES
    AmenitiesService,
    AnalyticsService,
    BottomSheetService,
    MinimapService,
    MobileButtonService,
    RelatedPreviewsService,
    ConfigurationService,
    ConversorService,
    CredentialsService,
    DvmService,
    ViewDeterminationService,
    ViewerService,
    Viewer3dService,
    VenueConfigurationsService,
    FilterService,
    LayoutService,
    NavigationService,
    PopoverService,
    PortalService,
    PreviewService,
    TemplateService,
    ToastService,
    TranslationService,
    UiService,
    ViewService,
    ViewerRouteParamsService,
];

/** Providers completos del bootstrap standalone, incluida su sesión local. */
export const APP_PROVIDERS: (Provider | EnvironmentProviders)[] = [
    ...APP_CORE_PROVIDERS,
    ...AuthProvider,
];
